import React from 'react';
import LegalDocumentContent from './LegalDocumentContent';

const LegalDocumentPage = ({ type = 'privacy' }) => (
  <div className="min-h-screen bg-[#F6F8FB] px-4 py-8 sm:px-6 lg:px-10 lg:py-10">
    <LegalDocumentContent type={type} />
  </div>
);

export default LegalDocumentPage;
